module.exports = __webpack_public_path__ + "static/media/bg.ade2995f.png";